import { useEffect, useState } from 'react';

import type { ASDClient } from '@vgtv/asd-client';

import { useIdentity } from '../IdentityProvider/IdentityProvider';
import { getASDClient } from '../../services/asd';

export const useASDClient = (callback: () => void) => {
  const { sessionData } = useIdentity();
  const [asdClient, setAsdClient] = useState<ASDClient>();

  const userId = sessionData?.userId;

  useEffect(() => {
    if (!userId) {
      return;
    }

    (async () => {
      try {
        const asd = await getASDClient(String(userId), callback);

        setAsdClient(asd);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [userId]); // eslint-disable-line react-hooks/exhaustive-deps

  return { asdClient };
};
